declare let require: Function;

export const environment = {
    API_URL: 'https://dev.hpos.heartland.us/api/d',
    API_BASE: 'https://dev.hpos.heartland.us/api',
    isProduction: true,
    ENVIRONMENT: 'dev',
    VERSION: require('../../package.json').version,
    BUCKET: 'https://bucket.dev.hpos.heartland.us',
};